import React from 'react';
import { Flex } from '@adobe/react-spectrum';
import { View } from '@react-spectrum/view';
import { ColorPicker } from 'app/views/components/editor/pickers/ColorPicker';
import { SizePicker } from 'app/views/components/editor/pickers/SizePicker';
import { ToolPicker } from 'app/views/components/editor/platform/desktop/workspace/imageAnnotate/ToolPicker';
import { Divider } from 'app/views/components/editor/sidebar/Divider';
import { Insertion } from 'app/views/components/editor/sidebar/Insertion';
import { Selection } from 'app/views/components/editor/sidebar/Selection';
import { getPerpendicularDirection } from 'app/utils/varia';
const PaddingForLayout = {
    row: 'size-100',
    column: 'size-25',
};
const BackgroundForLayout = {
    row: 'gray-50',
    column: 'gray-75',
};
const BorderForLayout = {
    row: {
        borderEndWidth: 'thin',
        borderBottomWidth: 'none',
    },
    column: {
        borderEndWidth: 'none',
        borderBottomWidth: 'thin',
    },
};
export const Sidebar = () => {
    const mainViewLayout = configGet('desktopMainViewLayout', 'row');
    const direction = getPerpendicularDirection(mainViewLayout);
    const defaultOverflow = mainViewLayout === 'row' ? 'hidden' : 'visible';
    return (React.createElement(View, { "data-test-id": "toolbar-wrapper", UNSAFE_className: "sidebar tool-picker", borderEndColor: "gray-200", borderBottomColor: "gray-200", paddingY: PaddingForLayout[mainViewLayout], backgroundColor: BackgroundForLayout[mainViewLayout], overflow: defaultOverflow, borderEndWidth: BorderForLayout[mainViewLayout].borderEndWidth, borderBottomWidth: BorderForLayout[mainViewLayout].borderBottomWidth },
        React.createElement(Flex, { width: "100%", minHeight: "100%", maxHeight: "100%", direction: direction },
            React.createElement(View, { flex: "1", overflow: "hidden auto", paddingX: "size-200" },
                React.createElement(ToolPicker, { direction: direction })),
            React.createElement(View, { paddingX: "size-200" },
                React.createElement(Flex, { direction: direction, gap: "size-175" },
                    React.createElement(Insertion, { direction: direction }),
                    React.createElement(Selection, { direction: direction }),
                    React.createElement(Divider, null),
                    React.createElement(ColorPicker, null),
                    React.createElement(SizePicker, null))))));
};
